import styled from 'styled-components';
import { media } from 'styled-bootstrap-grid';
import { Link } from 'shared-routing';
import { Button } from '../Button';

export const LinkButton = styled(Button)`
  display: inline-flex;
  align-self: flex-start;
  width: auto;
`;

export const StyledLink = styled(Link)`
  display: flex;
  justify-content: flex-start;
  width: auto;
  align-items: center;
  color: ${({ theme }) => theme.defaultColors.black};
  padding: 0.8rem 1rem 1.4rem 0;

  ${media.md`
    padding: 1rem 1rem 1.5rem 0;
  `}

  ${media.lg`
    padding: 1rem 0;
  `}
`;

export const StyledSpan = styled.span`
  display: flex;
  align-items: center;
  gap: 1rem;
`;
